import {HashRouter, Route, Routes} from "react-router-dom";
import {Helmet} from "react-helmet";
import {Menu} from "./components/Menu";
import {Contacts} from "./pages/Contacts";
import React, {Suspense} from "react";
import {Video} from "./pages/Video";
import {Documents} from "./pages/Documents";
import {Ufa} from "./pages/Ufa";
import {Download} from "./pages/Download";
import "bootstrap/dist/css/bootstrap.min.css";
import "./App.css";
import useVideo from "./utils/hooks/video";
import ScrollToTop from "./utils/ScrollToTop";
import {Home2} from "./pages/Home2";
import {Platform} from "./pages/Platform";
import {Parts} from "./pages/Parts";
import {Tarifs} from "./pages/Tarifs";
import {Ai} from "./pages/Ai";
import {Hire} from "./pages/Hire";
import {Support} from "./pages/Support";
import {Footer} from "./components/Footer";
import {PrivacyPolicy} from "./pages/PrivacyPolicy";
import {Home} from "./pages/Home";
import {Services} from "./pages/Services";
import {OtherTask1} from "./pages/Other/task1";
import {OtherTasks} from "./pages/Other/tasks";
import {useTranslation} from "react-i18next";
import {Blogs} from "./pages/Blogs";
import {Blog} from "./pages/Blogs/blog";
import {News} from "./pages/News";

function App() {
    useVideo();
    const {t} = useTranslation();
    return (
        <Suspense fallback="loading">
            <Helmet>
                <meta name="description" content={t('meta.description')}/>
                <meta name="og:title" content={t('meta.title')}/>
                <meta name="og:description" content={t('meta.description')}/>
            </Helmet>
            <HashRouter>
                <div className="bg-light">
                    <div className="container">
                        <ScrollToTop/>
                        <Menu/>
                        <Routes>
                            <Route path="/" element={<Home2/>}/>
                            <Route path="/old" element={<Home/>}/>
                            <Route path="/video" element={<Video/>}/>
                            <Route path="/documents" element={<Documents/>}/>
                            <Route path="/contacts" element={<Contacts/>}/>
                            <Route path="/ufa" element={<Ufa/>}/>
                            <Route path="/download" element={<Download/>}/>
                            <Route path="/platform" element={<Platform/>}/>
                            <Route path="/parts" element={<Parts/>}/>
                            <Route path="/tarifs" element={<Tarifs/>}/>
                            <Route path="/ai" element={<Ai/>}/>
                            <Route path="/hire" element={<Hire/>}/>
                            <Route path="/support" element={<Support/>}/>
                            <Route path="/services" element={<Services/>}/>
                            <Route path="/privacypolicy" element={<PrivacyPolicy/>}/>
                            <Route path="/other/task1" element={<OtherTask1/>}/>
                            <Route path="/other/tasks" element={<OtherTasks/>}/>
                            <Route path="/blogs" element={<Blogs/>}/>
                            <Route path="/blog/:id" element={<Blog/>}/>
                            <Route path="/news" element={<News/>}/>
                        </Routes>
                        <Footer/>
                    </div>
                </div>
            </HashRouter>
        </Suspense>
    );
}

export default App;
